import React, { useState, useEffect } from 'react'

// styles
import styles from './index.module.scss'
import ExploreSortMenu from 'components/Menu/ExploreSortMenu'
import SortIcon from 'assets/icons/sort-icon-normal.svg?component'
import GradientButton from 'components/Button/GradientButton'
import FilterIcon from 'assets/icons/filter-icon.svg?component'
import OutlineButton from 'components/Button/OutlineButton'

const ExplorePageTab = props => {
  const {
    tabType,
    setTabType,
    selectedSort,
    sortList,
    handleSelectSort,
    showFilter,
    setShowFilter,
    openMobileFilter,
    setOpenMobileFilter,
    total,
  } = props

  const [selectedSortList, setSelectedSortList] = useState<any[]>([])

  useEffect(() => {
    let array: any[] = []
    sortList.map(item => {
      let object: any = item
      if (item.value === selectedSort.value) object.checked = true
      else object.checked = false
      array.push(object)
    })
    setSelectedSortList(array)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSort])

  return (
    <div className={styles.container}>
      <div className="lg:hidden block mt-[30px] lg:mt-[0px]">
        <div className={styles.signature}>Explore</div>
        <div className={styles.result}>{total} results</div>
      </div>
      <div className="w-full flex flex-wrap justify-between gap-[20px] lg:gap-[15px]">
        <div className="w-full lg:hidden block mt-[30px]">
          <div className={styles.tabContainer}>
            <div className="min-w-[106px]">
              {tabType === 0 ? (
                <GradientButton
                  label="Artwork"
                  backgroundColor={'var(--bg-FFF-202427)'}
                  fullWidth
                  height={43}
                  onClick={() => {}}
                />
              ) : (
                <OutlineButton
                  label="Artwork"
                  backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
                  fontFamily="Jost-Regular"
                  color="var(--bg-A5A5A5-606060)"
                  borderColor="transparent"
                  fullWidth
                  height={43}
                  onClick={() => {
                    setTabType(0)
                  }}
                />
              )}
            </div>

            <div className="min-w-[130px]">
              {tabType === 1 ? (
                <GradientButton
                  label="Collections"
                  backgroundColor={'var(--bg-FFF-202427)'}
                  fullWidth
                  height={43}
                  onClick={() => {}}
                />
              ) : (
                <OutlineButton
                  label="Collections"
                  backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
                  fontFamily="Jost-Regular"
                  color="var(--bg-A5A5A5-606060)"
                  borderColor="transparent"
                  fullWidth
                  height={43}
                  onClick={() => {
                    setTabType(1)
                  }}
                />
              )}
            </div>

            <div className="min-w-[104px]">
              {tabType === 2 ? (
                <GradientButton
                  label="Profiles"
                  backgroundColor={'var(--bg-FFF-202427)'}
                  fullWidth
                  height={43}
                  onClick={() => {}}
                />
              ) : (
                <OutlineButton
                  label="Profiles"
                  backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
                  fontFamily="Jost-Regular"
                  color="var(--bg-A5A5A5-606060)"
                  borderColor="transparent"
                  fullWidth
                  height={43}
                  onClick={() => {
                    setTabType(2)
                  }}
                />
              )}
            </div>
          </div>
        </div>

        <div className="w-full flex lg:hidden">
          {tabType !== 2 && (
            <div
              className={`${styles.profileFilter} ${showFilter ? styles.selectedFilter : styles.unselectedFilter}`}
              onClick={() => setOpenMobileFilter(!openMobileFilter)}
            >
              <FilterIcon />
            </div>
          )}
          <ExploreSortMenu
            categoryList={selectedSortList}
            handleSelectCategory={index => handleSelectSort(selectedSortList[index])}
            icon={<SortIcon />}
          />
        </div>

        <div className="w-full hidden lg:w-auto lg:flex lg:gap-[15px] xl:gap-[30px] 2xl:gap-[74px] lg:mt-[30px] xl:mt-[0px] items-center">
          <div>
            <div className={styles.signature}>Explore</div>
            <div className={styles.result}>{total} results</div>
          </div>

          <div>
            <div className={styles.tabContainer}>
              <div className="min-w-[106px]">
                {tabType === 0 ? (
                  <GradientButton
                    label="Artwork"
                    backgroundColor={'var(--bg-FFF-202427)'}
                    fullWidth
                    height={43}
                    onClick={() => {}}
                  />
                ) : (
                  <OutlineButton
                    label="Artwork"
                    backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
                    fontFamily="Jost-Regular"
                    color="var(--bg-A5A5A5-606060)"
                    borderColor="transparent"
                    fullWidth
                    height={43}
                    onClick={() => {
                      setTabType(0)
                    }}
                  />
                )}
              </div>

              <div className="min-w-[146px]">
                {tabType === 1 ? (
                  <GradientButton
                    label="Collections"
                    backgroundColor={'var(--bg-FFF-202427)'}
                    fullWidth
                    height={43}
                    onClick={() => {}}
                  />
                ) : (
                  <OutlineButton
                    label="Collections"
                    backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
                    fontFamily="Jost-Regular"
                    color="var(--bg-A5A5A5-606060)"
                    borderColor="transparent"
                    fullWidth
                    height={43}
                    onClick={() => {
                      setTabType(1)
                    }}
                  />
                )}
              </div>

              <div className="min-w-[104px]">
                {tabType === 2 ? (
                  <GradientButton
                    label="Profiles"
                    backgroundColor={'var(--bg-FFF-202427)'}
                    fullWidth
                    height={43}
                    onClick={() => {}}
                  />
                ) : (
                  <OutlineButton
                    label="Profiles"
                    backgroundColor={'rgba(var(--main-bg-color-rgb), 0.1)'}
                    fontFamily="Jost-Regular"
                    color="var(--bg-A5A5A5-606060)"
                    borderColor="transparent"
                    fullWidth
                    height={43}
                    onClick={() => {
                      setTabType(2)
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="hidden lg:flex lg:mt-[30px] xl:mt-[0px] items-center">
          {tabType !== 2 && (
            <div
              className={`${styles.profileFilter} ${showFilter ? styles.selectedFilter : styles.unselectedFilter}`}
              onClick={() => setShowFilter(!showFilter)}
            >
              <FilterIcon />
            </div>
          )}
          <ExploreSortMenu
            categoryList={selectedSortList}
            handleSelectCategory={index => handleSelectSort(selectedSortList[index])}
            icon={<SortIcon />}
          />
        </div>
      </div>
    </div>
  )
}

export default ExplorePageTab
